export const Position = {
  MAIN_SWIPE_ID: 1,  // 首頁輪播圖
  MAIN_ADV_ID: 3,  // 首頁下廣告
  MY_ADV_ID: 4,  // 我的下廣告
}
